import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlannerAppointmentMissingQualifications } from '~constants/api';

import { Paginated, Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { Appointment } from '~weekly-planner/lib/common';

import { typePrefix as prefix } from '~weekly-planner/actions/appointments';

export const typePrefix = `${prefix}-missing-qualifications`;

export const missingQualificationsApi = createApi({
  reducerPath: 'weeklyPlannerMissingQualificationsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlannerAppointmentMissingQualifications }),
  tagTypes: ['missing-qualifications'],
  endpoints: (builder) => ({
    getMissingQualifications: builder.query<Paginated<Appointment>, Request>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'missing-qualifications', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Paginated<Appointment>>(payload),
    }),
  }),
});

export const { useGetMissingQualificationsQuery } = missingQualificationsApi;
